export enum EXTERNAL_SERVICES_ENUM {

    NOMINATIM_OPENSTREET_MAP = "https://nominatim.openstreetmap.org/"

}